import { dateTimeFormat } from "src/utils/utils";
import styles from "./cardSetting.module.scss";
import { Link } from "react-router-dom";
import { EMPTY_STRING } from "src/components/constant/constant";
import { Avatar } from "@mui/material";
import { CardSettingType } from "./cardSettingSlice";
import { bgColorbyName } from "src/variable/randomColor";

const columns = [
  {
    title: "Id",
    dataIndex: "card_setting_id",
    key: "card_setting_id"
  },
  {
    title: "Ppan",
    dataIndex: "ppan",
    key: "ppan",
    render: (ppan: string) => <div>{ppan ? "****" + ppan.slice(-4) : EMPTY_STRING}</div>
  },
  {
    title: "Card Setting Status",
    dataIndex: "card_setting_status",
    key: "card_setting_status"
  },
  {
    title: "Card Id",
    dataIndex: "card_id",
    key: "card_id"
  },
  {
    title: "Expiry At",
    dataIndex: "expires_at",
    key: "expires_at",
    render: (expires_at: string) => <div>{expires_at ? dateTimeFormat(Number(expires_at)).datetime : "---"}</div>
  },
  {
    title: "Status",
    dataIndex: "status",
    key: "status",
    render: (status: string) => (
      <div className={styles.tableCardStatus}>
        <div className={`${status === "ACTIVE" ? styles.green : styles.grey}`}>{status}</div>
      </div>
    )
  },
  {
    title: "User",
    dataIndex: "user_id",
    key: "user_id",
    render: (user_id: string, data: CardSettingType) => (
      <Link to={`/users/${user_id}`} className={styles.tableMember}>
        {data?.user ? (
          <>
            <div className={styles.tableMemberImg}>
              <Avatar
                id="av"
                aria-label="Recipe"
                style={{ backgroundColor: bgColorbyName(data?.user?.first_name ?? "") }}
              >
                {data?.user?.first_name?.charAt(0).toLocaleUpperCase()}
              </Avatar>
            </div>
            <div className={styles.tableMemberDetail}>
              <div className={styles.tableMemberName}>{`${data?.user?.first_name} ${data?.user?.last_name}`}</div>
              <div className={styles.tableMemberEmail}>{`${data?.user?.email}`}</div>
            </div>
          </>
        ) : (
          user_id
        )}
      </Link>
    )
  },
  {
    title: "Wallet",
    dataIndex: "wallet_id",
    key: "wallet_id",
    render: (wallet_id: string, data: CardSettingType) => (
      <Link to={`/wallets/${wallet_id}`} className={styles.tableMember}>
        {data?.wallet ? (
          <>
            <div className={styles.tableMemberImg}>
              <Avatar id="av" aria-label="Recipe" style={{ backgroundColor: bgColorbyName(data?.wallet?.name ?? "") }}>
                {data?.wallet?.name?.charAt(0).toLocaleUpperCase()}
              </Avatar>
            </div>
            <div className={styles.tableMemberDetail}>
              <div className={styles.tableMemberName}>{`${data?.wallet?.name}`}</div>
              <div className={styles.tableMemberEmail}>{`${data?.wallet?.description}`}</div>
            </div>
          </>
        ) : (
          wallet_id
        )}
      </Link>
    )
  },
  {
    title: "Type",
    dataIndex: "sub_type",
    key: "sub_type"
  },
  {
    title: "Updated At",
    dataIndex: "updated_at",
    key: "updated_at",
    render: (updated_at: string) => <div>{dateTimeFormat(updated_at).datetime}</div>
  }
];

export default columns;
